import { withTranslation } from 'react-i18next';
import { isTablet, isIOS } from 'react-device-detect';
import { Box } from '@mui/material';
import { createGlobalStyle } from 'styled-components';
import { SwiperSlide } from 'swiper/react';
import { ISelectEventContentProps } from './interfaces';
import SelectEventItem from './SelectEventItem';
import { useStyles } from './styles';
import SwiperWrapper from '@components/SwiperWrapper';
import { SwiperScreenSizes } from '@interfaces';

// fix for iPad bouncy scroll bar issue
const GlobalStyle = createGlobalStyle`
  html, body {
    height: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch; /* momentum inside the container */
    overscroll-behavior: contain; /* don’t chain to the viewport */
  }
`;

const SelectEventContent = ({
  events,
  selectedEvent,
  setSelectedEvent,
  t: translate,
}: ISelectEventContentProps) => {
  const isIpadFix = isTablet && isIOS;
  const classes = useStyles();
  const alwaysOnEvents = events.filter((x) => x.isAlwaysOn);
  const scheduledEvents = events.filter((x) => x.isScheduled);

  const breakpointsForEvents = {
    [SwiperScreenSizes.Mobile1]: {
      slidesPerView: 2,
      spaceBetween: 24,
    },
    [SwiperScreenSizes.Mobile2]: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
    [SwiperScreenSizes.Mobile3]: {
      slidesPerView: 3,
      spaceBetween: 44,
    },
    [SwiperScreenSizes.Tablet]: {
      slidesPerView: 3,
      spaceBetween: 52,
    },
    [SwiperScreenSizes.TabletHorizontal]: {
      slidesPerView: 4,
      spaceBetween: 54,
    },
  };

  return (
    <Box sx={classes.root}>
      {isIpadFix && <GlobalStyle />}
      <SwiperWrapper breakpoints={breakpointsForEvents}>
        {alwaysOnEvents.map((event) => (
          <SwiperSlide key={event.eventId}>
            <SelectEventItem
              event={event}
              isSelectedEvent={selectedEvent?.eventId === event.eventId}
              setSelectedEvent={setSelectedEvent}
            />
          </SwiperSlide>
        ))}
      </SwiperWrapper>
      {!alwaysOnEvents.length && (
        <Box sx={classes.noEvents}>
          {translate('eventPage.noAlwaysOnEvents')}
        </Box>
      )}
      <Box sx={classes.divider} />
      <Box sx={classes.subTitle}>
        {translate('eventPage.scheduledEvents')}
        {+(scheduledEvents.length || 0) > 0 && (
          <span style={classes.scheduledEventsCounter}>
            ({scheduledEvents.length})
          </span>
        )}
        :
      </Box>
      <SwiperWrapper breakpoints={breakpointsForEvents}>
        {scheduledEvents.map((event) => (
          <SwiperSlide key={event.eventId}>
            <SelectEventItem
              showDateBar
              event={event}
              isSelectedEvent={selectedEvent?.eventId === event.eventId}
              setSelectedEvent={setSelectedEvent}
            />
          </SwiperSlide>
        ))}
      </SwiperWrapper>
      {!scheduledEvents.length && (
        <Box sx={classes.noEvents}>
          {translate('eventPage.noScheduledEvents')}
        </Box>
      )}
    </Box>
  );
};

export default withTranslation()(SelectEventContent);
